import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ChatMicro,
  ChevronDownMicro,
  ChevronUpMicro,
  PhoneMicro,
} from "../../assets/SvgIcons";
const FaqAndContactSection = ({ faqs, title, email, phone }) => {
  const [expanded, setExpanded] = useState(null);

  const toggleAccordion = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  return (
    <div className="lg:py-16 md:py-14 sm:py-12">
      <div className="bg-[#F3F3F3] rounded-lg mx-auto p-8">
        {/* Contact Section */}

        <div className="contact-section mb-8">
          <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-4">
            {title ? title : "Frequently Asked Questions"}
          </h2>{" "}
          {email && phone && (
            <div className="flex text-sm items-center">
              <div className="flex items-center gap-2">
                {PhoneMicro}
                <span className="mr-4">+852 3002 0310</span>
              </div>
              <div className="flex items-center gap-2">
                {ChatMicro}
                <Link
                  to="/info/contact.htm?selectMenu=BeforeOrder"
                  className=" hover:underline"
                >
                  Contact
                </Link>
              </div>
            </div>
          )}
        </div>

        {/* FAQ Accordion Section */}
        <div className="contact-faq-section ">
          <div className="accordion">
            {faqs?.map((faq) => (
              <div key={faq?.id} className="accordion-item border-b">
                <button
                  onClick={() => toggleAccordion(faq?.id)}
                  className="accordion-head w-full text-left p-4 lg:text-md md:text-md sm:text-sm font-medium flex justify-between items-center"
                >
                  <p>{faq?.question}</p>
                  {expanded === faq?.id ? ChevronUpMicro : ChevronDownMicro}
                </button>

                <div
                  className={` transition-all text-[14px] duration-300 ease-in-out overflow-hidden ${
                    expanded === faq?.id ? "max-h-[800px] " : "max-h-0 "
                  }`}
                >
                  <div
                    className={`  transition-opacity duration-300 ${
                      expanded === faq?.id ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    <p className="accordion-body px-4 pb-4 text-gray-700 lg:text-sm md:text-sm sm:text-xs">
                      {faq?.answer}
                    </p>
                  </div>
                </div>

                {/* {expanded === faq?.id && (
                  <p className="accordion-body p-4 text-gray-700 lg:text-sm md:text-sm sm:text-xs">
                    {faq?.answer}
                  </p>
                )} */}
              </div>
            ))}
          </div>
        </div>

        {/* Link to More FAQs */}
        <div className=" mt-8">
          <Link
            to="mailto:info@wristlink.app"
            className=" border border-black lg:text-md md:text-md sm:text-sm px-4 py-2 rounded text-black hover:bg-gray-300"
          >
            Customer Service
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FaqAndContactSection;
